import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children, isAuth }) {
  console.log("...Welcome to Titan web page...");

  if (isAuth) {
    return children;
  } else return <Navigate to={"/login"} />;
}
